// apps/web/src/pages/admin/calendar/calendar-operations.ts — Phase 5 plan 05-05
// (B5 calendar + day-tap routing).
//
// GraphQL operation constants for the admin Calendar surface.
// The reuse pattern matches today-operations.ts / reservations-operations.ts:
// operation names carry the page suffix so the 401-retry interceptor
// in lib/api.ts routes them through the admin reauth path.
//
// createBlockedPeriod + deleteBlockedPeriod + blockedPeriods are the
// Phase-3 settings flow operations — the calendar REUSES them for the
// single-day block + the blocked-ranges list management.

import { gql } from "graphql-request";

// `Block.availability(month)` is the public read endpoint that returns
// the 5-state classifier output per Phase 3 D-04. The admin calendar
// uses the same field set.
export const AVAILABILITY_MONTH_QUERY = gql`
  query AvailabilityMonthCalendar($month: String!) {
    availability(month: $month) {
      date
      state
      reasons
    }
  }
`;

// Quick 260803-ger: re-export DayStateKind so the merged Reservations
// page can pick it up without an additional import path.
export type { DayStateKind } from "./CalendarDayTapDialog";

const BLOCKED_PERIOD_FIELDS = `
  id
  fromDate
  toDate
  fromTime
  toTime
  reason
`;

export const BLOCKED_PERIODS_QUERY = gql`
  query BlockedPeriodsCalendar {
    blockedPeriods {
      ${BLOCKED_PERIOD_FIELDS}
    }
  }
`;

// Phase 5 plan 05-03 (CAL-04): read-only capacity footer. Same shape as
// todaySummary (booked / capacity / holdback / remaining).
export const DATE_SUMMARY_QUERY = gql`
  query DateSummaryCalendar($date: String!) {
    dateSummary(date: $date) {
      booked
      capacity
      holdback
      remaining
    }
  }
`;

export const CREATE_BLOCKED_PERIOD_MUTATION = gql`
  mutation CreateBlockedPeriodCalendar(
    $input: BlockedPeriodInput!
    $forceFlag: Boolean!
  ) {
    createBlockedPeriod(input: $input, forceFlag: $forceFlag) {
      blockedPeriod {
        ${BLOCKED_PERIOD_FIELDS}
      }
      conflicts {
        id
        date
        time
        partySize
      }
      conflictingReservationCount
      requiresForce
    }
  }
`;

export const DELETE_BLOCKED_PERIOD_MUTATION = gql`
  mutation DeleteBlockedPeriodCalendar($id: ID!) {
    deleteBlockedPeriod(id: $id)
  }
`;

// Phase 5 plan 05-05 (CAL-02): the unblockDay mutation — admin-only.
// Returns {success, unblockedDate} per the schema's UnblockDayResult.
export const UNBLOCK_DAY_MUTATION = gql`
  mutation UnblockDayCalendar($date: String!) {
    unblockDay(date: $date) {
      success
      unblockedDate
    }
  }
`;
